<!-- GIF图片组件 -->
<template>
    <div>
        <div>
            <i class="el-icon-video-play fs70"></i>
        </div>
    </div>
</template>

<script>
/**
 * GIF图片组件
 */
import { base64TransformByURL } from '@/common/imgbase64'
export default {
    name: 'gif',
    props: {
        images: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            gifImg: null,
            bufferImages: []
        }
    },
    watch: {
        images: {
            handler(val) {
                if (val) {
                    console.log('watch images handler')
                    let netRequest = []
                    this.images.forEach(item => {
                        netRequest.push(base64TransformByURL(item.Url))
                    })
                    Promise.all(netRequest).then(res => {
                        this.bufferImages = res
                        console.log(res)
                        // this.createGif()
                    })
                    // this.createGif()
                }
            },
            immediate: true
        }
    },
    methods: {}
}
</script>
<style lang='less' scoped>
</style>
